import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import './AppoinmentHistory.css';
import './Dashboard.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {axiosInstance} from './helper/axiosConfig';
import { Link, useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

function ChangePassword() {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmNewPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errors, setErrors] = useState({});
  const history = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validatePassword = (password) => {
      const minLength = 8;
      const hasNumber = /\d/;
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

      if (password.length < minLength || !hasNumber.test(password) || !hasSpecialChar.test(password)) {
          return false;
      }
      return true;
  };

  const validateForm = () => {
    const newErrors = {};
    // if (!formData.newPassword) newErrors.newPassword = "New password is required";
    if (!formData.newPassword) toast('New password is required.');
    if (!formData.confirmNewPassword) newErrors.confirmNewPassword = "Please confirm your new password";
    if (formData.newPassword && formData.newPassword !== formData.confirmNewPassword) {
      newErrors.confirmNewPassword = "Passwords do not match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.newPassword) {
      toast.error("New password is required.")
      return;
    }
    if (!formData.confirmNewPassword) {
      toast.error('Please confirm your new password.');
      return;
    }
    if (formData.newPassword && formData.newPassword !== formData.confirmNewPassword) {
      toast.error('Passwords do not match.');
      return;
    }
    if (!validatePassword(formData.newPassword)) {
        toast.error('Password must be at least 8 characters long and include numbers and special characters.');
        return;
    }
    // if (!validateForm()) return;

    setLoading(true);
    setSuccessMessage('');
    setErrors({});
    try {
      await toast.promise(
        axiosInstance.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/auth/password/change/`, {
          new_password1: formData.newPassword,
          new_password2: formData.confirmNewPassword,
        }),
        {
          loading: 'Changing password...',
          success: <b>Password changed successfully!</b>,
          error: <b>Failed to change password.</b>,
        }
      );
      // setLoading(false);
      setFormData({ newPassword: '', confirmNewPassword: '' });
      history('/dashboard'); // Redirect after success
    } catch (error) {
      if (error.response && error.response.data) {
        setErrors(error.response.data);
      }
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-main">
        <Header />
        <div className="content-box create-doctor">
          <div className="patient-details-container create-patient">
            <div className="patient-header appoinment-header">
              <div className="back-icon-wrapper">
                <Link to="/dashboard">
                  <FontAwesomeIcon icon={faArrowLeft} className="back-icon" />
                </Link>
              </div>
              <div className="center-content">
                <h2 className="profile-name">Change Password</h2>
              </div>
            </div>

            <div className="patient-info-div">
              <div className="patient-info appoinment-info">
                <form onSubmit={handleSubmit} className="patient-info-form create-prescription">
                  {/* New Password Field */}
                  <div className="form-group">
                    <label>New Password</label>
                    <input
                      type="password"
                      name="newPassword"
                      placeholder="Enter New Password"
                      value={formData.newPassword}
                      onChange={handleInputChange}
                      required
                      className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                    />
                    {errors.newPassword && <div className="invalid-feedback">{errors.newPassword}</div>}
                  </div>

                  {/* Confirm New Password Field */}
                  <div className="form-group">
                    <label>Confirm New Password</label>
                    <input
                      type="password"
                      name="confirmNewPassword"
                      placeholder="Enter New Password Again"
                      value={formData.confirmNewPassword}
                      onChange={handleInputChange}
                      required
                      className={`form-control ${errors.confirmNewPassword ? 'is-invalid' : ''}`}
                    />
                    {errors.confirmNewPassword && <div className="invalid-feedback">{errors.confirmNewPassword}</div>}
                  </div>

                  {/* Submit Button */}
                  <div className="form-group submit-button-container">
                    <button type="submit" className="submit-btn" disabled={loading}>
                      {loading ? 'Changing...' : 'Change Password'}
                    </button>
                  </div>
                  {successMessage && <div className="alert alert-success">{successMessage}</div>}
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-content">
            {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
